import React from 'react';
import PropTypes from 'prop-types';
import NextImage from 'next/image';
import { Tooltip } from '@web/atoms';
import checkIcon from '../../images/Icons/Check.png';
import {
  Card,
  Info,
  StyledImage,
  Name,
  CardContent,
  IconContainer,
  KeyInfo,
  Description,
} from './styles.js';

export const SimplifiedProductCardCRO = ({
  label,
  title,
  checked = false,
  img,
  onChange,
  unavailable,
  unavailableText = 'This item is unavailable.',
  notSelectable,
  notSelectableText = 'To choose this item, please remove one of your previous selections.',
  level,
  height,
}) => {
  const getProductCard = props => (
    <Card
      {...props}
      $checked={checked}
      $unavailable={unavailable}
      $notSelectable={notSelectable}
      $height={height}
      aria-label={`${label} ${title}`}
      onClick={onChange}
    >
      <CardContent>
        <StyledImage $checked={checked} $unavailable={unavailable}>
          <NextImage src={img.src} alt={img.alt} width={65} height={65} />
        </StyledImage>
        <Info>
          <KeyInfo>
            <Name as={level} $checked={checked}>
              {title}
            </Name>
            <IconContainer>
              {checked && <NextImage src={checkIcon} width={28} height={28} />}
            </IconContainer>
          </KeyInfo>
        </Info>
      </CardContent>
      {unavailable && <Description>{unavailableText}</Description>}
    </Card>
  );

  return notSelectable && !unavailable ? (
    <Tooltip trigger={getProductCard} placement="top" offsetY={-200}>
      {notSelectableText}
    </Tooltip>
  ) : (
    getProductCard()
  );
};

SimplifiedProductCardCRO.displayName = 'SimplifiedProductCardCRO';
SimplifiedProductCardCRO.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  unavailable: PropTypes.bool,
  unavailableText: PropTypes.string,
  notSelectable: PropTypes.bool,
  notSelectableText: PropTypes.string,
  checked: PropTypes.bool,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  height: PropTypes.number,
};
